export default __webpack_public_path__ + "static/media/bridal.e4d9a669.jpg";